export default __webpack_public_path__ + "static/media/tv_nameless.91caf5f8.webp";